import { apiClient, type TruckClassExEntity } from '@/libs/api'

export type FetchTruckClassQuery = {
  tenantKey: string
  truckClassId: number
}

export const fetchTruckClass = async (
  { tenantKey, truckClassId }: FetchTruckClassQuery,
  signal?: AbortSignal
): Promise<TruckClassExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .truck_classes._id(truckClassId)
    .$get({
      config: {
        signal
      }
    })
  return data
}
